export default {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
